import { rootRoute } from "@/routing/routes";
import { createRoute } from "@tanstack/react-router";
import { SelectProvincePage } from ".";

export const selectProvince = createRoute({
  path: "/select-province",
  getParentRoute: () => rootRoute,
  component: SelectProvincePage,
});

export const selectProvinceRoutes = selectProvince;
